import { defineMessages } from 'react-intl';

export default defineMessages({
  filter: 'Filter',
  singleSelectionQuestion: 'Single choice question',
  multipleSelectionQuestion: 'Multiple choice question',
  zipQuestion: 'Zip question',
  unknown: 'Unknown',
  city: 'City',
  largeTowns: 'Large towns',
  elsewhereInCountry: 'Elsewhere in country',
  scoreDoughnutLabel: 'Score',
  score: 'Your score',
  industryScore: 'Industry score',
  veryDissatisfied: 'Very dissatisfied',
  dissatisfied: 'Dissatisfied',
  neither: 'Neither',
  satisfied: 'Satisfied',
  verySatisfied: 'Very satisfied',
  averageScore: 'Average score: {score}',
  'language-subtitle': 'Language of the browser used when answering.',
  'countryCode-subtitle': 'Based in the IP-address of the computer used when answering.',
  'device-subtitle': 'Type of device used based on the browsers user-agent string.',
  'webpageUrl-subtitle': 'The page the user answered from.',
  'regionId-subtitle': 'Based on zip question',
  'municipalityId-subtitle': 'Based on zip question',
  'grades-subtitle': 'The average is calculated on a scale from 1 to 5, where 1 is very poor and 5 is very good',
  'npsScore-subtitle': 'NPS = % Promoters (9-10) - % Detractors (0-6)',
  'findScore-subtitle': 'Find Score = % Yes - % No',
  'dependent-subtitle': '{operator, select, OR {or} AND {and} other {}} answered {answer} to the question "{question}"',
  desktop: 'Desktop',
  tv: 'TV',
  tablet: 'Tablet',
  mobile: 'Mobile',
  phone: 'Phone',
  bot: 'Bot',
  car: 'Car',
  console: 'Console',
  summary: 'Summary',
  role: 'Role Summary',
  purpose: 'Purpose Summary',
  otherRoles: 'Other roles Summary',
  profile: 'Profile Summary',
  geo: 'Geo Summary',
  findAnalysis: 'Find analysis Summary',
  csiScore: 'CSI score',
  nps: 'NPS',
  additionalQuestions: 'Additional questions Summary',
  inactiveQuestions: 'Inactive questions Summary',
  csi: 'CSI Summary',
  page: 'Page',
  entryPage: 'Entry page',
  overall: 'Overall',
  graphic: 'Design',
  structure: 'Navigation',
  information: 'Content',
  'user friendliness': 'User friendliness',
  expectations: 'Expectations',
  average: 'Average',
  find: 'Find',
  satisfaction: 'Satisfaction',
  expectancy: 'Expectancy',
  ideal: 'Ideal',
  grade: 'Grade',
  addToReport: 'Add text responses to report',
  textResponseCount: '{start}-{end} of {total} items',
  flaggedCommentsCountQuestionnaire: '{count} responses exluded due to potential personal data',
  flaggedCommentsCount: '{count} responses may contain personal data',
  manageFlaggedComments: 'Manage flagged comments',
  loadingChart: 'Loading chart...',
  tags: 'Tags',
  keywords: 'Keywords',
  sentiment: 'Sentiment',
  theme: 'Tag',
  addTheme: 'Add new tag',
  tagComments: 'Categorize comments',
  selectTag: 'Select tag',
  addTagToAll: 'Add to {count} responses',
  removeTagFromAll: 'Remove from {count} responses',
  newThemePlaceholder: 'New name',
  editTag: 'Rename tag',
  removeTag: 'Remove tag',
  tagUsed: 'Tag is used in {count} responses',
  positive: 'Positive',
  neutral: 'Neutral',
  negative: 'Negative',
  reportComment: 'Report personal data',
  reportCommentPersonalDataAllowed: 'Mark for deletion of personal data',
  reportCommentContent: 'Do you want to report this comment for containing personal data?',
  translateComment: 'View translation',
  'responses-subtitle': 'Number of responses collected, for percentage it compares to number of views',
  'views-subtitle': 'Number of times the survey has been shown, segments not possible.',
  yes: 'Yes',
  no: 'No',
  showPreviousStep: 'Show filtered out data from previous step',
  showDropOff: 'Show drop off',
  responses: 'Responded',
  noresponse: 'Did not respond',
  direct: 'Direct entry',
  website: 'Websites',
  campaign: 'Campaigns',
  social: 'Socal networks',
  search: 'Search engines',
  ai: 'AI assistants',
  comparisonReportChartTitle: '"{question}" compared to "{comparedTo}"',
  noMatchingData: 'Ooops, no data here. Try a different time period!',
  noMatchingDataReport: 'Ooops, no data here.',
  exceededLimit: 'Only the first {limit} out of {total} responses are shown',
  generateSummary: 'Generate',
  aiSummaries: 'AI summaries',
  showSummarySegments: 'Generate',
  hideSummarySegments: 'Hide segments',
  retrySummary: 'Retry summary',
  regenerateSummary: 'Regenerate',
  summaryStale: 'This saved summary does not match the current filters or responses. Regenerate it to summarize the current results.',
  aiGeneratedSummary: 'AI-generated summary',
  summaryGeneratedAt: 'Generated {date}',
  summaryTemporary: 'Temporary preview. A fresh summary will be generated when the report is created.',
  summaryLowVolume: 'At least 5 eligible responses are needed for an AI summary ({count} available).',
  summaryNothingEligible: 'No responses can be sent to the model. Flagged or unscanned answers are excluded.',
  summaryFailed: 'The AI summary could not be generated.',
  summaryLoadFailed: 'The AI summary could not be loaded. Please try again.',
  summaryGenerating: 'Generating AI summary…',
  summaryCapped: 'This summary covers the first {limit} of {total} responses, matching the table.',
  summaryScope: '{segment} · {count} eligible responses',
  summaryDisabledLicense: 'AI summaries are not enabled on this data source.',
  summaryDisabledPii: 'AI summaries require PII scanning.',
  summaryDisabledPersonalData: 'AI summaries are unavailable when personal data is allowed.',
});
